import { retrieveFromStorage } from "../../Components/Functions";
import Api from "../../Server/Api";
import { USER_AUTHENTICATION_DATA } from "../User/types";
import { UPDATE } from "./types";


const api = new Api();

const { business = {} } = retrieveFromStorage(USER_AUTHENTICATION_DATA) || {};


export const updateMessages = (data = {}) => {
	return async (dispatch) => {
		const res = {}// await api.get({ endpoint: "business/" + business?.identity + "/messages/" });
		if(res) dispatch({ type: UPDATE, alert: res });
	}
};
